{
  "error_talent": "error contact",
  "delete_talent": "Delete contact",
  "profession": "Profession",
  "skill": "Skill",
  "age_min": "Age min",
  "age_max": "Age max",
  "location_country": "Country",
  "location_city": "City",
  "rest_filter": "Rest filter",
  "add_all": "Add all selected contacts",
  "profile_picture": "Profile picture",
  "first_name": "First name",
  "last_name": "Last name",
  "professions": "Professions",
  "actions": "Actions"
}
